import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import dashboardImg from "../../assets/dashboard-mockup.jpg";
import ScrollReveal from "./ScrollReveal";

const HeroSection = () => {
  const { t } = useTranslation();

  return (
    <section className="assist-hero">
      <div className="assist-container">
        <div className="assist-hero-inner">
          <ScrollReveal>
            <div className="assist-hero-badge assist-mb-6">
              <span className="assist-badge-dot" />
              {t("hero.badge", "Plateforme SaaS · Maintenance digitale par QR Code")}
            </div>
          </ScrollReveal>

          <ScrollReveal delay={80}>
            <h1 className="assist-hero-title assist-mb-6">
              {t("hero.title", "Digitalisez vos interventions techniques avec un simple scan")}
            </h1>
          </ScrollReveal>

          <ScrollReveal delay={160}>
            <p className="assist-hero-text assist-mb-8">
              {t(
                "hero.subtitle",
                "Chaque machine reliée à un QR code, chaque intervention tracée, chaque rapport généré automatiquement. Une plateforme web + mobile pour centraliser et automatiser toute votre maintenance."
              )}
            </p>
          </ScrollReveal>

          <ScrollReveal delay={240}>
            <div className="assist-hero-actions">
              <a href="/download" className="assist-btn-primary">
                {t("download_app", "Télécharger l'application")}
              </a>

              <Link to="/features" className="assist-btn-secondary">
                {t("hero.discover", "Découvrir la plateforme")}
              </Link>
            </div>
          </ScrollReveal>

          <ScrollReveal delay={320}>
            <div className="assist-hero-media">
              <div className="assist-hero-shot">
                <img
                  src={dashboardImg}
                  alt="Tableau de bord AssistByScan – gestion des interventions et QR codes"
                  className="assist-media-img"
                  loading="lazy"
                  width="1600"
                  height="1000"
                />
              </div>
              <div className="assist-hero-glow" />
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;